import React from "react";
import { useParams } from "react-router-dom";
import { useHotel } from "../contexts/HotelContext";
import { Link } from "react-router-dom";
import OfferWizard from "../components/offer-wizard/OfferWizard";

const CreateOffer: React.FC = () => {
  const { currentHost } = useHotel();
  const { id } = useParams<{ id: string }>();
  const isEditing = !!id;

  const getHotelDisplayName = () => {
    if (currentHost === "demo.hotelb2b.com") {
      return "Demo Hotel";
    }
    const subdomain = currentHost.split(".")[0];
    return `Hotel ${subdomain.charAt(0).toUpperCase() + subdomain.slice(1)}`;
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <nav className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-semibold text-neutral-900">
                {getHotelDisplayName()} - B2B Offers
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <Link to="/offers" className="btn-secondary">
                Back to Offers
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <main>
        <OfferWizard offerId={id} isEditing={isEditing} />
      </main>
    </div>
  );
};

export default CreateOffer;
